import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Oferta, OfertaPack } from "../ofertas-pack-list.component";
import { Utils } from 'src/app/common/utils';;

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

let sinBordes = [false, false, false, false];

export async function createPdfListOfertasPack(logo, oferta: Oferta, fecha_actual) {

    let content_articulos = await fillTableOfertaPacks(oferta?.packs,oferta.tipo_precio);

    let docDefinition: any = {
        styles: {
            texto_destacado: {
                bold: true
            },
            socio: {
                bold: true,
                fontSize: 8
            },
            parrafos_socio: {
                fontSize: 8
            },
            tabla_derecha: {
                alignment: "right"
            },
            parrafos_sociedad: {
                fontSize: 8,
                alignment: "center"
            },
            parrafos_mini_sociedad: {
                fontSize: 7,
                alignment: "center"
            },
            titulo20: {
                fontSize: 12,
                bold: true,
                alignment: "right",
                margin: [0, 0, 20, 0]
            },
            alinear_center: {
                alignment: "center"
            },
            alinear_derecha: {
                alignment: "right"
            },
            tabla_fecha: {
                fontSize: 10,
                alignment: "center",
                bold: true
            },
            obsevaciones_table: {
                bold: true,
                fontSize: 8
            },
            texto_categoria: {
                fontSize: 7
            },
            fondo_blanco: {
                background: '#ffffff'
            },
            tableFecha: {
                margin: [0, 5, 0, 0]

            }


        },
        //
        content: [
            { image: logo, width: 150 },
            {

                layout: 'noBorders',
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {

                                layout: 'noBorders',
                                table: {
                                    widths: ['*'],
                                    body: [

                                        [
                                            { text: (oferta ? oferta.nombre : ''), style: ["tabla_derecha"], border: sinBordes }
                                        ],
                                        [
                                            { text: (oferta ? oferta.direccion : ''), style: ["tabla_derecha"], border: sinBordes }
                                        ],
                                        [
                                            { text: (oferta ? oferta.poblacion : ''), style: ["tabla_derecha"], border: sinBordes }
                                        ],
                                        [
                                            { text: (oferta ? oferta.provincia : ''), style: ["tabla_derecha"], border: sinBordes }
                                        ],
                                        [
                                            { text: (oferta ? oferta.pais : ''), style: ["tabla_derecha"], border: sinBordes }
                                        ],
                                        [
                                            { text: oferta ? oferta.telefono : '', style: ["tabla_derecha"], border: sinBordes }
                                        ]

                                    ]
                                },
                                border: sinBordes
                            }
                        ]
                    ]

                },

            },
            {
                text: 'ANGEBOT', fontSize: 17
            },
            {

                layout: 'noBorders',
                style: 'tableFecha',
                table: {
                    widths: [150, 150],
                    body: [
                        [
                            { text: 'Datum ' + fecha_actual, fontSize: 10 }, { text: '', fontSize: 10 }
                        ]
                    ]


                },
            },
            {
                text: 'DETAIL ARTIKEL', fontSize: 10, margin: [0, 5, 0, 0], 
            },
            {
                table: {
                    widths: [80,60, '*'],
                    body:  content_articulos
                        // [await fillTableArticulos(oferta.articulos)]
                        /* [
                        { text: 'Foto'	, fillColor: '#cfcfcf' },
                        { text: 'Artículo'	, fillColor: '#cfcfcf' },
                        { text:	'Color', fillColor: '#cfcfcf'	 },
                        { text: 'Tamaño', fillColor: '#cfcfcf'	 },
                        { text: 'Precio' , fillColor: '#cfcfcf'}
                        ] */
                    
                }
            }

        ]
    }
     pdfMake.createPdf(docDefinition).open({}, window['Informe']); 

}



function fillTableOfertaPacks(packs: OfertaPack[], tipo): Promise<any> {

    let content_table_pack = [];
    
    return new Promise( resolve => {
    
        let header = new Array( 
            { text: 'Foto'	, fillColor: '#cfcfcf', style: {bold: true,fontSize: 13,color: 'black'},alignment: 'center' },
            { text: 'Pack'	, fillColor: '#cfcfcf', style: {bold: true,fontSize: 13,color: 'black'},alignment: 'center' },
            { text: 'Mix Paket'	, fillColor: '#cfcfcf', style: {bold: true,fontSize: 13,color: 'black'},alignment: 'center' }
        )
        content_table_pack.push(header)

        for (let i = 0; i < packs.length; i++) {
            let row = new Array();
            let pack = packs[i];
            var image = {};
           
            
            if (pack.imagen == null || pack.imagen.length == 0){
                 image = { text: '' ,  };
            } else {
                 image = { image: pack.imagen ? pack.imagen: '' , width: (pack.ancho / 2) , height: (pack.alto / 1.5) };
            }
            
            var nombre = { text: pack.nombre ? pack.nombre: ''  };


            let headerTableArticles = new Array(
                { text: 'Prod.', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Artikel', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Beschreibung', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Topf', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Stk/Mix', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Stk/CC', fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' },
                { text: 'Preis' + ' ' + tipo, fillColor: '#cfcfcf', style: {bold: true,fontSize: 11,color: 'black'},border:[0,0,0,1],alignment: 'center' }
            );

            let estructoContent = ['proveedor','nombre','descripcion','maceta','cantidad','unidades_cc','precio'];

            var articles = generateTable(headerTableArticles,pack['articulos'],estructoContent);

            row.push(image);
            row.push(nombre);
            row.push(articles);

            content_table_pack.push(row);

            //content_table_pack.push(row);
            if ((i + 1) >= pack.articulos.length ) {
                resolve(content_table_pack);
            }
        }
    });
}

/**
 * 
 * @param header Un array de la cabecera que tendra la tabla -> estructura [{text: '', fillColor: 'FFFFFF'}] 
 * @param content Un array del contenido que tendra la tabla 
 * @param structoContent Si el contenido es mayor al de la cabecera deberemos indicar que datos queremos escoger para la tabla
 */
function generateTable(header,content,structoContent=null) {
    var body = [];

    body.push(header);

    for (const one in content) {
            const element = content[one];
            
            var row = new Array();
            
            if(structoContent != null) {
                for (const key in structoContent) {
                    if (Object.prototype.hasOwnProperty.call(structoContent, key)) {
                        let aux = element[structoContent[key]] ? element[structoContent[key]] : ''; 
                        row.push({text:aux,border:[0,0,0,0]});
                    }
                }
                body.push(row);
            }else{
                for (const article in element) {
                    if (Object.prototype.hasOwnProperty.call(element, article)) {
                        const text = element[article] ? element[article] : '';
                        row.push(text);
                    }
                }
                body.push(row);

            }

    }
    var table = {
        table: {
          headerRows: 1,
          body: body,
        },styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },
    }

    return table;
}

function decimalFormat(input: any, nDecimals?: number, millar?: string, comma?: string, progressiveTo?: number) {
    if (!input) {
        return '';
    }
    return Utils.decimalFormat(input, nDecimals, millar, comma, progressiveTo);
}
  